import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ButtonToolbar } from 'reactstrap';
import { BUS_MAINTENANCE_STAY_PATH } from '../../../../config/paths';
import BusMaintenanceStayDeleteButton from './BusMaintenanceStayDeleteButton';

const BusMaintenanceStayToolbar = ({ busMaintenanceStayId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <Link
        className="btn btn-primary"
        to={`${BUS_MAINTENANCE_STAY_PATH}/${busMaintenanceStayId}/edit`}
      >
        <i className="fa fa-pencil-square-o" /> Llenar Datos de Mantenimiento
      </Link>{' '}
      <BusMaintenanceStayDeleteButton
        busMaintenanceStayId={busMaintenanceStayId}
      />
    </div>
  </ButtonToolbar>
);

BusMaintenanceStayToolbar.propTypes = {
  busMaintenanceStayId: PropTypes.number.isRequired,
};

export default BusMaintenanceStayToolbar;
